export class VehicleRepairDto {

  public id!: string;
  public /* readonly */ recorded!: Date;
  public notes: string | undefined;
  public readonly completed: Date | undefined;
  public onInvoice!: boolean;
  public readonly vehicleId!: string;

  constructor(init?: Partial<VehicleRepairDto> | undefined) {
    Object.assign(this, init);
    if (init?.recorded) {
      this.recorded = new Date(init.recorded);
    }
    if (init?.completed) {
      this.completed = new Date(init.completed);
    }
  }

  public isEditable(): boolean {
    return true;
  }
}
